import request from './request';
/**
 * 获取版本记录
 */
export function getVersionRecord(params) {
    return request('/version/list', {
        method: 'GET',
        params,
    });
}
/**
 * 检查是否有新版本需要弹窗提示
 */
export function checkUpdate() {
    return request('/version/update-prompt', {
        method: 'GET',
    });
}
/**
 * 版本更新提示标记已读
 */
export function markRead(params) {
    return request('/version/mark-read', {
        method: 'POST',
        params,
    });
}
